export const teamFactory = (
  name: string,
  emoji: string,
  users: string[],
  companyId: string,
) => {
  return {
    name: name,
    emoji: emoji,
    users: users,
    companyId: companyId,
  };
};
